module.exports = __webpack_public_path__ + "static/media/4565326.f27177bf.jpg";